<form [formGroup]="stateForm" class="search-form">
  <div class="input-wrapper">
    <input
      (keydown)="customStopPropagation($event)"
      (input)="processSearchSubject$.next(stateForm.value)"
      [matAutocomplete]="autoGroup"
      [title]="currentTitle"
      id="search-input-field"
      class="search-input"
      type="text"
      maxlength="100"
      matInput
      formControlName="searchTerm"
      required
      placeholder="Søk i kartet" />
    @if (stateForm.get('searchTerm')?.value || markerVisible) {
      <button
        (click)="clearSearch()"
        (keydown.enter)="clearSearch()"
        class="cancel-btn"
        disableRipple
        matSuffix
        mat-icon-button
        aria-label="Clear">
        <mat-icon class="cancel-icon">close</mat-icon>
      </button>
    }
  </div>

  <mat-autocomplete
    #autoGroup="matAutocomplete"
    hideSingleSelectionIndicator="true"
    (optionSelected)="onChange($event.option.value)"
    [displayWith]="displayFn">
    @for (group of stateGroupOptions | async; track group) {
      <mat-optgroup [label]="''">
        <div class="group-header">
          <mat-icon class="group-icon" [ngClass]="getGroupIconClass(group.category)" aria-hidden="false">
            {{ getGroupIcon(group.category) }}
          </mat-icon>
          <span class="group-label">{{ group.category }}</span>
        </div>
        <div class="group-options-wrapper">
          @for (data of group.data; track data) {
            <mat-option
              [value]="data"
              [title]="data.title"
              [ngClass]="group.category === 'Adresse/matrikkel' ? 'category-property' : ''">
              @if (group.category === 'Adresse/matrikkel') {
                <button (click)="getProperties(data)" class="agri-btn" title="Søk på landbrukseiendom">
                  <mat-icon aria-hidden="false" aria-label="Adresse/matrikkel ikon">agriculture</mat-icon>
                </button>
              }
              <span>{{ data.title }}</span>
            </mat-option>
          }
        </div>
      </mat-optgroup>
    }
  </mat-autocomplete>
</form>
